import { request, methods } from "./request";
import { definitions, paths } from "../schema/api";

export type ShareResourceParentsChildrenGetParam =
  paths["/share_resource/{id}/parents_children"]["get"]["parameters"]["query"];
export type ShareResourceParentsChildrenGetResponse =
  paths["/share_resource/{id}/parents_children"]["get"]["responses"][200]["schema"];
export type ShareResourcesGetParam =
  paths["/share_resources"]["get"]["parameters"]["query"];
export type ShareResourcesGetResponse =
  paths["/share_resources"]["get"]["responses"][200]["schema"];
export type ShareResourcesPutParam =
  paths["/share_resources"]["put"]["parameters"]["body"];
export type ShareResourcesPutResponse =
  paths["/share_resources"]["put"]["responses"][200]["schema"];
type ShareResourcePostIdResponse =
  paths["/share_resource/{id}"]["post"]["responses"][200]["schema"];
export type ShareResourcesDeleteResponse =
  paths["/share_resources"]["delete"]["responses"][200]["schema"];

class ShareResource {
  getWithParentsChildren(
    id: number,
    params: ShareResourceParentsChildrenGetParam,
    token: string
  ): Promise<ShareResourceParentsChildrenGetResponse> {
    return request({
      token,
      params,
      resource: `share_resource/${id}/parents_children`,
      method: methods.Get,
    });
  }
  getBulk(
    params: ShareResourcesGetParam,
    token: string
  ): Promise<ShareResourcesGetResponse> {
    return request({
      token,
      params,
      method: methods.Get,
      resource: "share_resources",
    });
  }
  put(
    params: ShareResourcesPutParam,
    token: string
  ): Promise<ShareResourcesPutResponse> {
    const resourceDataPayload = new FormData();
    resourceDataPayload.append('client_id', `${params.client_id}`);
    resourceDataPayload.append('parent_id', `${params.parent_id}`);
    resourceDataPayload.append('file_names', params.file_names.join(","));
    resourceDataPayload.append('file_types', params.file_types.join(","));
    resourceDataPayload.append('file_comments', params.file_comments.join(","));
    resourceDataPayload.append('folder_names', params.folder_names.join(","));
    resourceDataPayload.append('folder_comments', params.folder_comments.join(","));
    params.files.forEach((value) => {
      if (value) {
        resourceDataPayload.append(`files[]`, value);
      }
    });

    return request({
      token,
      params: resourceDataPayload,
      resource: `share_resources`,
      method: methods.Put,
    });
  }
  post(
    id: number,
    share_resource: definitions["ShareResource"],
    token: string = ""
  ): Promise<ShareResourcePostIdResponse> {
    return request({
      token,
      params: share_resource,
      resource: `share_resource/${id}`,
      method: methods.Post,
    });
  }
  deleteByIds(
    ids: number[],
    token: string
  ): Promise<ShareResourcesDeleteResponse> {
    return request({
      token,
      resource: `share_resources?share_resource_ids=${ids.join(",")}`,
      method: methods.Delete,
    });
  }
}

export { ShareResource };
